import PropTypes from 'prop-types';
import React from 'react';

import { ImageSimple } from '$partials/media/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const ModuleCardDuoBlock = ({
    heading = '',
    pageLeft = null,
    pageRight = null
}) => {
    return (
        <section className='layout-container overflow-hidden'>
            {/* heading */}
            {heading && (
                <div className='layout-grid-negative-gutter sm:flex my-40 sm:mb-40 sm:mt-100'>
                    <div className='hidden md:block w-1/12 layout-grid-col-padding' />

                    <div className='w-full sm:w-7/12 layout-grid-col-padding'>
                        <h2 className='type-style-1 whitespace-pre-wrap'>
                            {heading}
                        </h2>
                    </div>
                </div>
            )}

            <div className='layout-grid-negative-gutter sm:flex'>
                <div className={`w-full sm:w-6/12 layout-grid-col-padding mb-60${heading ? ' sm:mt-60' : ' sm:mt-0'}`}>
                    {/* image left */}
                    <figure className='w-[100vw] sm:w-[50vw] -ml-20 sm:-ml-40 md:-ml-60'>
                        {pageLeft?.listingImageLarge && (
                            <ImageSimple
                                {...pageLeft.listingImageLarge}
                                className='w-full aspect-square sm:aspect-[8/5] object-cover object-center overflow-hidden pointer-events-none select-none' />
                        )}
                    </figure>

                    {/* text left */}
                    <div className='layout-grid-negative-gutter sm:flex mt-30 sm:mt-60'>
                        <div className='hidden md:block w-1/6 layout-grid-col-padding' />

                        <div className='w-full sm:w-5/6 layout-grid-col-padding flex flex-col gap-10 sm:gap-20'>
                            {/* eyebrow */}
                            {pageLeft?.calendarItemType && (
                                <p className='type-style-4'>
                                    {pageLeft.calendarItemType}
                                </p>
                            )}

                            {/* title */}
                            {pageLeft?.title && (
                                <p className='type-style-2'>
                                    {pageLeft.title}
                                </p>
                            )}

                            {/* listing text */}
                            {(pageLeft?.description || pageLeft?.listingText) && (
                                <div
                                    className='type-style-4'
                                    dangerouslySetInnerHTML={{ __html: pageLeft?.description || pageLeft?.listingText }} />
                            )}

                            {/* cta */}
                            <p>
                                <a
                                    className='pill-button gtm-find-out-more'
                                    href={pageLeft.url}>
                                    Find out more
                                </a>
                            </p>
                        </div>
                    </div>
                </div>

                <div className={`w-full sm:w-6/12 layout-grid-col-padding mb-60 mt-40${heading ? ' sm:mt-60' : ' sm:mt-0' }`}>
                    {/* image right */}
                    <figure className='w-[100vw] sm:w-[50vw] -ml-20 sm:-ml-10 md:-ml-15'>
                        {pageRight?.listingImageLarge && (
                            <ImageSimple
                                {...pageRight.listingImageLarge}
                                className='w-full aspect-square sm:aspect-[8/5] object-cover object-center overflow-hidden pointer-events-none select-none' />
                        )}
                    </figure>

                    {/* text right */}
                    <div className='layout-grid-negative-gutter sm:flex mt-30 sm:mt-60'>
                        <div className='hidden md:block w-1/6 layout-grid-col-padding' />

                        <div className='w-full sm:w-5/6 layout-grid-col-padding flex flex-col gap-10 sm:gap-20'>
                            {/* eyebrow */}
                            {pageRight?.calendarItemType && (
                                <p className='type-style-4'>
                                    {pageRight.calendarItemType}
                                </p>
                            )}

                            {/* title */}
                            {pageRight?.title && (
                                <p className='type-style-2'>
                                    {pageRight.title}
                                </p>
                            )}

                            {/* listing text */}
                            {(pageRight?.description || pageRight?.listingText) && (
                                <div
                                    className='type-style-4'
                                    dangerouslySetInnerHTML={{ __html: pageRight?.description || pageRight?.listingText }} />
                            )}

                            {/* cta */}
                            <p>
                                <a
                                    className='pill-button gtm-find-out-more'
                                    href={pageRight.url}>
                                    Find out more
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    heading: PropTypes.string,
    pageLeft: PropTypes.object,
    pageRight: PropTypes.object
};

ModuleCardDuoBlock.propTypes = propTypes;

export default ModuleCardDuoBlock;
